import { Address } from '@vfde-sails/avc-core';
import { AddressForm } from '../interface';

/**
 * Converts an AddressForm object coming from user input into an Address object.
 * Enables the usage of zipcodes instead of city names in the same input field.
 * @param {AddressForm} address - user input
 * @returns {Partial<Address>} - result address with zipcode or city name
 */
export const formToAddress = ({ city, street, housenumber }: AddressForm): Partial<Address> => {
    const cityIsZipcode = Number.isInteger(parseInt(city));

    return {
        zipcode: cityIsZipcode ? city : '',
        city: cityIsZipcode ? '' : city,
        street,
        housenumber,
    };
};
